export enum SUPPORTED_CURRENCY {
  AU = 'AUD',
  NZ = 'NZD',
  UK = 'GBP',
}
